import { CollectionModelFieldLine } from '@ikegps/core-shared';
import {
	type LineFieldPolylineClasses,
	lineFieldPolylineNodes,
	lineFieldPolylineStyles,
} from '../../../components/line.field.polyline';
import { addStyles } from '../../../components/theme';
import { type MithrilVNode } from '../../../mithril';
import { PointCache } from '../../google/projection.cache';

// Topo-specific class names — kept stable because map.print.capture.ts selects `__vector` by name.
const CSS: LineFieldPolylineClasses = {
	container: 'c-TopologicalEditorMapPolyline',
	vector: 'c-TopologicalEditorMapPolyline__vector',
	highlight: 'c-TopologicalEditorMapPolyline__highlight',
	clickTarget: 'c-TopologicalEditorMapPolyline__clickTarget',
};

addStyles(lineFieldPolylineStyles(CSS));

interface MapPolylineOptions {
	field: CollectionModelFieldLine;
	onClick?: () => void;
}

export class MapPolyline {
	constructor(private opts: MapPolylineOptions) {}

	get nodes(): MithrilVNode | null {
		return lineFieldPolylineNodes(this.opts.field, CSS, (lat, lng) => PointCache.getPoint(lat, lng), this.opts.onClick);
	}
}
